<div class="toast show" role="alert" aria-live="assertive" aria-atomic="true">
  <div class="toast-header text-white border-0 p-3" [ngClass]="'bg-' + Notification.Type">
    <i class="bi fs-5 me-2"
      [ngClass]='{"bi-check-circle": Notification.Type ==="info" || Notification.Type === "success", "bi-exclamation-circle": Notification.Type ==="danger" || Notification.Type === "error"}'></i>
    <strong class="me-auto">{{ Notification.Message }}</strong>
    <span class="badge bg-secondary" *ngIf="Notification.Count! > 0">
      {{ Notification.Count }}
    </span>
    <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"
      (click)="destroyNotification()"></button>
  </div>
  <div class="toast-body bg-white" *ngIf="Notification.Body">
    {{ Notification.Body }}
  </div>
  <div class="toast-timer bg-info bg-gradient"></div>
</div>